angular.module('charts')
  .directive("studentAssignmentHistory", function() {
      return {
          restrict: "E",
          scope: {
              assignmentHistory: '=',
              showClassroom: '='
          },
          transclude: true,
          templateUrl: '/resources/charts/partials/student-assignment-history.html',
          controller: ['translateFilter', '$scope', '$timeout', 'assignedFocusApi', function(translateFilter, $scope, $timeout, assignedFocusApi) {

              $scope.sort = {
                  column: 'due_date',
                  descending: true
              };

              $scope.head = {
                  assign_name:       {label: "Assignment",      field: "focus_concept"},
                  due_date:          {label: "Assignment Date", field: "start_date"},
                  lessons_completed: {label: "Status",          field: "assignment_status"},
                  minutes_spent:     {label: "Time Spent",        field: "time_spent"},
                  proficiency:       {label: "Lessons",         field: "lessons_passed"},
                  try_lesson:        {label: "Details",         field: "" }
              };

              $scope.types = {};

              $scope.getTypes = function(list, property) {
                  var items = (list || []).
                  map(function (item) { return assignedFocusApi.getSupportedAssignmentType(item[property]); }).
                  filter(function (cat, idx, arr) { return arr.indexOf(cat) === idx; });

                  return items;
              };

              $scope.filterByType = function(assignment) {
                  var assignmentType = assignedFocusApi.getSupportedAssignmentType(assignment.assignment_type);
                  return $scope.types[assignmentType];
              };

              // $timeout(fn) ultimately calls setTimeout(fn, 0) which has the effect interrupting the Javascript execution
              // and allowing the browser to render the content first, before continuing the execution of that Javascript.
              $timeout(function () {
                  // checkboxes set to true by default
                  _.forEach($scope.getTypes($scope.assignmentHistory, 'assignment_type'), function(value) {
                      var assignmentType = assignedFocusApi.getSupportedAssignmentType(value);
                      $scope.types[assignmentType] = true;
                  });
              });

              $scope.onViewProgressClicked = function(assignment) {
                  $scope.$emit('viewProgressClick', assignment);
              };

              $scope.selectedColumn = function (column) {
                  return column === $scope.sort.column && 'sort-' + $scope.sort.descending;
              };

              $scope.updateSorting = function (column) {
                  var sort = $scope.sort;
                  if (sort.column === column) {
                      sort.descending = !sort.descending;
                  } else {
                      sort.column = column;
                      sort.descending = false;
                  }
              };

              $scope.isLongTermAssignment = function(assignment) {
                  return assignedFocusApi.isLongTermAssignment(assignment);
              };

              $scope.isNweaAssignment = function(assignment) {
                  return assignedFocusApi.isNweaAssignment(assignment);
              };

              $scope.getDisplayedAssignmentStatus = function(status) {
                  var translatableStatuses = translateFilter('assignments.statuses');

                  if (Object.keys(translatableStatuses).indexOf(status) > -1) {
                    return translatableStatuses[status];
                  }
                  return status;
              };
          }]
      };
  });
